var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
var PhoneNumber = /** @class */ (function (_super) {
    __extends(PhoneNumber, _super);
    function PhoneNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localPhoneNumber = _this.phoneNumber || null;
        return _this;
    }
    PhoneNumber.prototype.onPhoneNumberChanged = function (val) { this.$emit("update:phoneNumber", val); };
    __decorate([
        Prop({ type: Object, required: true })
    ], PhoneNumber.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], PhoneNumber.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String })
    ], PhoneNumber.prototype, "phoneNumber", void 0);
    __decorate([
        Watch("localPhoneNumber")
    ], PhoneNumber.prototype, "onPhoneNumberChanged", null);
    __decorate([
        Prop({ type: String, default: "phoneNumber" })
    ], PhoneNumber.prototype, "mPhoneNumber", void 0);
    __decorate([
        Prop({ type: String, default: "phoneNumber" })
    ], PhoneNumber.prototype, "$vPhoneNumber", void 0);
    PhoneNumber = __decorate([
        Component({
            name: "PhoneNumber",
            components: {
                FormGroup: FormGroup
            }
        })
    ], PhoneNumber);
    return PhoneNumber;
}(Vue));
export default PhoneNumber;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/PhoneNumber.vue
// module id = 121
// module chunks = 2 3 4 6